module.exports = __webpack_public_path__ + "static/media/mil53item.b6de557f.png";